var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVu(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 513,
    height: 343,
    viewBox: "0 0 513 343",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_301_56)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0.959961H513V342.953H0V0.959961Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M513 171.957V342.953H0L215.605 171.957H513Z",
    fill: "#6DA544"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M513 0.959961V171.956H215.605L0 0.959961H513Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.433 155.228L26.9205 0.959961H8.97349L217.548 166.38H513V155.228H221.433ZM8.97349 342.953H26.9205L221.433 188.685H513V177.532H217.548L8.97349 342.953ZM0 8.07684V22.3106L188.685 171.956L0 321.602V335.835L206.632 171.956L0 8.07684Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.97349 0.959961H0V8.07684L206.632 171.956L0 335.835V342.953H8.97349L217.548 177.532H513V166.38H217.548L8.97349 0.959961Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.8429 208.409V194.087C78.1358 194.087 89.7634 182.458 89.7634 168.167C89.7634 158.055 81.5364 149.828 71.4237 149.828C64.5352 149.828 58.9303 155.432 58.9303 162.322C58.9303 166.727 62.5143 170.311 66.9199 170.311C68.1173 170.31 69.2653 169.833 70.112 168.987C70.9587 168.14 71.4351 166.992 71.4367 165.794H85.7596C85.7596 176.183 77.3081 184.635 66.9209 184.635C54.6179 184.633 44.6084 174.623 44.6084 162.321C44.6084 147.534 56.6379 135.504 71.4247 135.504C89.4348 135.504 104.087 150.156 104.087 168.167C104.087 190.355 86.0341 208.409 63.8429 208.409Z",
    fill: "#FFDA44"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_301_56"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 513,
    height: 342,
    fill: "white",
    transform: "translate(0 0.956055)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVu);
export default __webpack_public_path__ + "static/media/VU.37cfe69bda61ea42a7b9b3eb2c97c04c.svg";
export { ForwardRef as ReactComponent };